import Slider from "react-slick"
import CenteredHero from "@/components/CenteredHero"
import GeneralLayout from "@/layouts/General"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import clsx from "clsx"
import { useLayoutEffect, useState, useEffect } from "react"
import "@/assets/css/slider.css"
import ContentMAPI from "@/app/api/content-management/content-management"
import { useGlobalContext } from "@/global/GlobalContext"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
const contentMApi = new ContentMAPI()

const OurOhana = () => {
  const { notifyError } = useGlobalContext()
  const [imgIndex, setImgIndex] = useState(1)
  const mediaSm = window.matchMedia("(min-width: 640px)")
  const [currWindowWidth, setCurrWindowWidth] = useState(window.innerWidth)
  const [skeletonCount, setSkeletonCount] = useState(5)
  const [onReq, isOnReq] = useState(true)
  const [employees, setEmployees] = useState([])
  const settings = {
    className: "center",
    centerMode: true,
    centerPadding: "0px",
    infinite: true,
    // slidesToShow: 5,
    slidesToShow: employees.length >= 5 ? 5 : employees.length,
    speed: 500,
    beforeChange: (current, next) => {
      setImgIndex(next + 1)
    },
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        // this breakpoints starts from the initial value to less
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
        }
      },
    ]
  };

  useEffect(() => {
    getEmployees()
  }, [])

  useLayoutEffect(() => {
    handleSkeletonCount()
  }, [])

  useLayoutEffect(() => {
    const handleResize = () => {
      handleSkeletonCount()

      setCurrWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)
  }, [currWindowWidth])

  const handleSkeletonCount = () => {
    if (window.innerWidth < 640) {
      setSkeletonCount(3)
    } else {
      setSkeletonCount(5)
    }
  }

  // API request
  const getEmployees = async () => {
    isOnReq(true)
    try {
      const { data } = await contentMApi.getEmployees()
      setEmployees(data.data.ohanas);
    } catch (err) {
      notifyError(err.message)
    }
    isOnReq(false)
  }

  return (
    <>
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        <CenteredHero title="Our Ohana" custParagraphFont="font-americanTC" paragraph="Ohana is family. Family means nobody gets left behind or forgotten" writer="- Lilo and Stitch" custCls="bg-[url('/src/assets/imgs/our-story/our-ohana/ohana-banner.jpg')] h-[50vh]" />
        <section className="pt-10 pb-20 px-6 sm:px-10 lg:px-14">
          {onReq ?
            <div className="flex items-center">
              {Array.from({ length: skeletonCount }, (_, i) => (
                <div key={i} className="h-40 md:h-48 lg:h-80 2xl:h-[360px] w-full">
                  <ContainerSkeleton custH="h-full" custW="w-full" custCls={i == Math.floor(skeletonCount / 2) && "slider--active-skeleton" || i != Math.floor(skeletonCount / 2) && "slider--side-skeleton"} />
                </div>
              ))}
            </div>
            :
            employees.length > 0 ?
              <Slider {...settings} className="our-ohana-slider--custom-center">
                {employees.map((e, i) => (
                  <div key={i} className={clsx("relative our-ohana-slide", {
                    " our-ohana--activeSlide": ((
                      (((i == imgIndex || (imgIndex == employees.length && i == 0)) && employees.length < 5) || ((i == imgIndex || imgIndex == employees.length && i == 0) && employees.length == 5) || (((imgIndex == 1 && i == 0) || (i == imgIndex - 1)) && employees.length > 5)) && mediaSm.matches) || (
                        ((imgIndex < 0 && i == (employees.length - 3))) || (imgIndex == 1 && i == 0) && !mediaSm.matches) || (
                        i == imgIndex - 1 && !mediaSm.matches))
                  })}>
                    {/* <div key={i} className={clsx("relative our-ohana-slide", {
                    " our-ohana--activeSlide": ((
                      (((i == imgIndex || imgIndex == employees.length && i == 0) && employees.length == 5) || (((imgIndex == 1 && i == 0) || (i == imgIndex - 1)) && employees.length > 5)) && mediaSm.matches) || (
                        ((imgIndex < 0 && i == (employees.length - 3))) || (imgIndex == 1 && i == 0) && !mediaSm.matches) || (
                        i == imgIndex - 1 && !mediaSm.matches))
                  })}> */}
                    <ImageSkeleton src={e.photo} custCls="object-cover w-full h-full" custH="h-40 md:h-48 lg:h-80 2xl:h-[360px]" isDarker />
                    {/* {(((((i == imgIndex || imgIndex == employees.length && i == 0) && employees.length == 5) || (((imgIndex == 1 && i == 0) || (i == imgIndex - 1)) && employees.length > 5)) && mediaSm.matches) || (((imgIndex < 0 && i == (employees.length - 3))) || (imgIndex == 1 && i == 0) && !mediaSm.matches) || (i == imgIndex - 1 && !mediaSm.matches)) && ( */}
                    {((
                      ((((i == imgIndex || (imgIndex == employees.length && i == 0)) && employees.length < 5) || (
                        i == imgIndex || imgIndex == employees.length && i == 0) && employees.length == 5) || (((imgIndex == 1 && i == 0) || (i == imgIndex - 1)) && employees.length > 5)) && mediaSm.matches) || (
                        ((imgIndex < 0 && i == (employees.length - 3))) || (imgIndex == 1 && i == 0) && !mediaSm.matches) || (
                        i == imgIndex - 1 && !mediaSm.matches)) && (
                        <div className="absolute bottom-0 bg-[rgba(255,255,255,0.5)] w-full text-center py-1 sm:py-2 text-charcoal-black">
                          <span className="font-agcasmlt font-light tracking-wide max-xs:text-xs text-base sm:text-xl max-xs:leading-3 leading-4 sm:leading-5">{e.name}</span>
                          {e.position &&
                            <span className="font-aAccSign max-xs:text-[10px] text-xs sm:text-base max-xs:leading-[10px] leading-3 sm:leading-3 block">{e.position}</span>
                          }
                        </div>
                      )}
                  </div>
                ))}
              </Slider>
              :
              <p className="text-center text-gray-500">No data available.</p>
          }
        </section>
      </GeneralLayout>
    </>
  )
}

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="slick-prev--custom max-xs:text-base text-xl sm:text-2xl lg:text-3xl max-xs:left-1 left-2 sm:left-4 lg:left-8" onClick={onClick}><FontAwesomeIcon icon={faChevronLeft} /></button>
  )
}

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="slick-next--custom max-xs:text-base text-xl sm:text-2xl lg:text-3xl max-xs:right-1 right-2 sm:right-4 lg:right-8" onClick={onClick}><FontAwesomeIcon icon={faChevronRight} /></button>
  )
}

export default OurOhana